import React from 'react'
import "../styles/about.css"
import Layout from '../components/Layout/Layout'
import { Link } from 'react-router-dom'

const About = () => {
  return (
    <Layout title={"Lastbites: About Us"}>
    <div className="responsive-container-block bigContainer">
  <div className="responsive-container-block Container">
    <img className="mainImg1" src="/Resources/aboutUsImg0.jpg"/>
    <div className="allText aboveText">
      <p className="text-blk headingText">"Welcome to Food Donate"</p>
      <p className="text-blk subHeadingText">
        <span style={{ textDecoration: 'underline', color: 'green' }}>
    About Us
</span>
      </p>
      <p className="text-blk description">
      We are a group of passionate people committed to addressing the difficulty of food waste in India. Our aim is to create a device that connects meals donors with charities and NGOs, even as additionally lowering the environmental effect of meals waste.
      </p>
      <Link to={"/contact"}><button className="contact">Contact Us</button></Link>
    </div>
  </div>
  <div className="responsive-container-block Container bottomContainer">
    <img
      className="mainImg1"
      src="/Resources/aboutUsImg1.jpg"
    />
    <div className="allText bottomText">
      <p className="text-blk headingText">"Welcome to Food Donation"</p>
      <p className="text-blk subHeadingText">
        <span style={{ textDecoration: 'underline', color: 'green' }}>
    About Us
</span>
      </p>
      <p className="text-blk description">
        We are a team of passionate individuals committed to addressing the issue of food waste in India. Our goal is to create a system that connects food donors with charities and NGOs, while also reducing the environmental impact of food waste.
      </p>
      <Link to={"/contact"}><button className="contact">Contact Us</button></Link>
    </div>
  </div>
</div>
</Layout>
    )
}

export default About
